<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})

const orderType = computed(() => props.params?.data?.quote?.orderType)
const typeLabel = computed(() => {
  const t = orderType.value
  if (!t) return '-'
  return t === 'SUBSCRIPTION' ? 'Récurrent' : 'OneShot'
})
const secondLine = computed(() => {
  const t = orderType.value
  if (!t) return ''
  if (t === 'SUBSCRIPTION') {
    const q = props.params?.data?.quote
    const dur = q?.subscriptionDuration
    const code = dur?.code ?? q?.subscriptionDurationCode ?? ''
    const months = parseInt(String(code), 10) || 0
    return months ? `${months} mois` : dur?.label ?? ''
  }
  return t === 'RENTAL' ? 'Leasing' : 'Standard'
})
</script>

<template>
  <div class="flex flex-col items-start leading-tight py-0.5">
    <span class="block text-sm">{{ typeLabel }}</span>
    <span v-if="secondLine" class="block text-[11px] text-base-content/80 mt-0.5">{{ secondLine }}</span>
  </div>
</template>
